export default "__VITE_ASSET__c53ab740__"